import io from "socket.io-client";

const SOCKET_OPTIONS = {
  transports: ["websocket", "polling"],
};

const socket = io(process.env.REACT_APP_URL_LINK, SOCKET_OPTIONS);

export default socket;
